import styles from './Pill.module.css';
import { IconButton } from '@chakra-ui/react';
import { ICON_BY_NAME } from '../Icons';
export interface PillProps {
  onClose: () => void;
}
export const Pill = ({
  onClose,
  children
}) => {
  return <div className={styles.container} data-sentry-component="Pill" data-sentry-source-file="Pill.tsx">
      {onClose && <IconButton aria-label={children} size="xs" borderRadius="100%" background="transparent" onClick={onClose} icon={<ICON_BY_NAME.close color="#4E4E5E" />} />}
      <div className={styles.textContainer}>{children}</div>
    </div>;
};